import {useQuery} from '@tanstack/react-query'
import React from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getRecommend} from '../../../apis/recommend/getRecommend'

const PAGE_SIZE = 5

const useQueryRecommend = (currentPage: number = 1) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.recommend.getRecommend(),
        queryFn: async () => {
            const {data, pageInfo} = await getRecommend(PAGE_SIZE, currentPage)
            return {data, pageInfo}
        },
    })

    return {data, refetch}
}

export default useQueryRecommend
